import React, { Component } from "react";
import { withRouter } from "./withRouter";
import { Popup } from "react-map-gl";

class NZ2026HomeTooltip extends Component {

  buildTooltip(hoverInfo, styledGeo, tooltip_pastcomp) {
    const { geoLevel } = this.props;
    if (!hoverInfo) return null;
    if (!styledGeo) return null;

    const { area_name, topLabel, area_id } = hoverInfo.props;

    // Find matching feature in styledGeo
    const comparatorFeature = styledGeo.features.find(
      f => f?.properties?.area_id === area_id
    );
    const comparator = comparatorFeature ? comparatorFeature?.properties : {};

    // Predicted vote shares (current prediction)
    const predictedValues = JSON.parse(hoverInfo.props._allValuesSorted);
    const Turnout = hoverInfo?.props?.Turnout ? JSON.parse(hoverInfo?.props?.Turnout) : null;
    // Parse diffTurnout from hover props
const diffTurnout = hoverInfo.props._diffTurnout != null
  ? typeof hoverInfo.props._diffTurnout === "string"
    ? parseFloat(hoverInfo.props._diffTurnout)
    : hoverInfo.props._diffTurnout
  : null;

// Then in the JSX:


    // Wave-on-wave diffs
    const hasPrevWave = hoverInfo.props._hasPrevWave === true || hoverInfo.props._hasPrevWave === "true";
    let diffByKey = {};
    if (hasPrevWave && hoverInfo.props._diffValuesSorted) {
      const diffValues = typeof hoverInfo.props._diffValuesSorted === "string"
        ? JSON.parse(hoverInfo.props._diffValuesSorted)
        : hoverInfo.props._diffValuesSorted;
      for (const d of diffValues) {
        diffByKey[d.key] = d.area_id; // the diff value
      }
    }

    const partyConfig = {
      nat_pred_n: { label: "National", color: "#0056A8" },
      act_pred_n: { label: "ACT", color: "#FFD700" },
      nzf_pred_n: { label: "NZF", color: "#000000" },
      lab_pred_n: { label: "Labour", color: "#E82C2C" },
      green_pred_n: { label: "Green", color: "#009639" },
      tpm_pred_n: { label: "TPM", color: "#CC0033" },
      top_pred_n: { label: "TOP", color: "#008080" },
      oth_pred_n: { label: "Other", color: "#999999" }
    };

    // Build vote share lines
    const voteLines = predictedValues.map(({ key, area_id }) => {
  const party = partyConfig[key];
  if (!party) return null;

  const predicted = area_id.toFixed(0);

  // Change from 2023 (always shown if available)
  let change2023 = "";
  if (tooltip_pastcomp === "no") {
    const pastVoteKey = key.replace("_pred_n", "").replace(/^/, "past_vote_");
    const prev = comparator?.[pastVoteKey] ?? null;
    if (prev !== null) {
      const diff = predicted - prev;
      change2023 = ` (${diff > 0 ? "+" : ""}${diff.toFixed(0)}%)`;
    }
  } else {
    const prev = comparator[key] ? comparator[key] * 100 : null;
    if (prev !== null) {
      const diff = predicted - prev;
      change2023 = ` (${diff > 0 ? "+" : ""}${diff.toFixed(0)}%)`;
    }
  }

  // Wave-on-wave change (shown in square brackets if present)
  let changeWave = "";
  if (hasPrevWave && diffByKey[key] !== undefined) {
    const diff = diffByKey[key];
    changeWave = ` [${diff > 0 ? "+" : ""}${diff.toFixed(0)}%]`;
  }

  return (
    <div key={key} style={{ color: party.color }}>
      {party.label}: {predicted}%
      {changeWave}
      {change2023}
    </div>
  );
});

    let area_type_label;
    switch (geoLevel) {
      case "constituency":
        area_type_label = "Electorate";
        break;
      default:
        area_type_label = geoLevel;
        break;
    }

    // Dynamic subtitle based on what's being compared
    const changeLabel = hasPrevWave
  ? " [change from last wave] (change from 2023)"
  : "(change from nominal 2023 result)";

return (
  <div style={{ fontSize: "13px" }}>
    <strong>{area_name}</strong> {area_type_label}
    <br />
    Winner: {topLabel}
    <br />
    Turnout: {Turnout ? Turnout.toFixed(0) + "%" : "n/a"}
{Turnout && diffTurnout !== null && (
  <span> [{diffTurnout > 0 ? "+" : ""}{diffTurnout.toFixed(0)}%]</span>
)}
    <br />
    <br />
    <div>Predicted vote shares</div>
    <div>{changeLabel}:</div>
    {voteLines}
    <br />
    <small>
      Click on an area to see how the Coalition is performing, or click a seat
      block to zoom in
    </small>
  </div>
);
  }

  render() {
    const { styledGeo, hoverInfo } = this.props;

    return (
      <>
        {styledGeo && hoverInfo && hoverInfo?.props?.topValue > 0 && (
          <Popup
            longitude={hoverInfo.lon}
            latitude={hoverInfo.lat}
            closeButton={false}
            closeOnClick={false}
            offset={12}
            dynamicPosition={true}
            maxWidth="500px"
          >
            {this.buildTooltip(hoverInfo, styledGeo, this.props.tooltip_pastcomp)}
          </Popup>
        )}
      </>
    );
  }
}

export default withRouter(NZ2026HomeTooltip);